module.exports = __webpack_public_path__ + "img/Group 97937.506ed04f.png";